export const getApi = () => {
  const host = "http://h.Card725.ir";
  const publishedHost = "";
  return process.env.NODE_ENV === "development" ? host : publishedHost;
};
